import { render } from "./PaymentSuccessFaqSection.vue?vue&type=template&id=7b3ce648"
import script from "./PaymentSuccessFaqSection.vue?vue&type=script&lang=js"
export * from "./PaymentSuccessFaqSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__